import { translate as t, translate } from '@nextcloud/l10n';
import DeleteSvg from '@mdi/svg/svg/delete.svg?raw';
import moment from '@nextcloud/moment';
import { getContents } from './services/trashbin';
// Register restore action
import './actions/restoreAction';
const Navigation = window.OCP.Files.Navigation;
Navigation.register({
    id: 'trashbin',
    name: t('files_trashbin', 'Deleted files'),
    caption: t('files_trashbin', 'List of files that have been deleted.'),
    icon: DeleteSvg,
    order: 50,
    sticky: true,
    defaultSortKey: 'deleted',
    columns: [
        {
            id: 'deleted',
            title: t('files_trashbin', 'Deleted'),
            render(node) {
                const deletionTime = node.attributes?.['trashbin-deletion-time'];
                const span = document.createElement('span');
                if (deletionTime) {
                    span.title = moment.unix(deletionTime).format('LLL');
                    span.textContent = moment.unix(deletionTime).fromNow();
                    return span;
                }
                // Unknown deletion time
                span.textContent = translate('files_trashbin', 'A long time ago');
                return span;
            },
            sort(nodeA, nodeB) {
                const deletionTimeA = nodeA.attributes?.['trashbin-deletion-time'] || nodeA?.mtime || 0;
                const deletionTimeB = nodeB.attributes?.['trashbin-deletion-time'] || nodeB?.mtime || 0;
                return deletionTimeB - deletionTimeA;
            },
        },
    ],
    getContents,
});
